module.exports = __webpack_public_path__ + "static/CircularStd-Bold-6baed2bf580964bec9559ad83caee43d.otf";